import { Injectable } from '@angular/core';
import { AngularFireDatabase } from '@angular/fire/database';
import { combineLatest, from, fromEvent, interval, merge, Observable } from 'rxjs';
import { map, startWith, mergeMap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ConnectionStatusService {
  public readonly online$: Observable<boolean>;

  constructor(private adb: AngularFireDatabase) {
    const onlineADB$ = interval(5000).pipe(
      mergeMap(() => from(this.adb.database.ref('.info/connected').once('value'))),
      map(snap => snap.val() as boolean),
      startWith(true)
    );

    const onlineEvents$ = merge(
      fromEvent(globalThis, 'online'),
      fromEvent(globalThis, 'offline')
    ).pipe(
      map(event => (event.target as typeof globalThis).navigator.onLine),
      startWith(globalThis.navigator.onLine)
    );

    this.online$ = combineLatest([
      onlineEvents$,
      onlineADB$
    ]).pipe(
      map(([onlineEvents, onlineADB]) => onlineEvents && onlineADB)
    );
  }
}
